import addDays from 'date-fns/addDays';
import isWithinInterval from 'date-fns/isWithinInterval';
import subDays from 'date-fns/subDays';
import localForage from 'localforage';
import orderBy from 'lodash/orderBy';
import { EventData } from '../../types';

export const PRINT_KEY = 'arrival-printer-id';
export const EVENT_KEY = 'arrival-event-id';

export async function storeItemId(params: { key: string; ItemId: number }) {
  await localForage.setItem(params.key, params.ItemId.toString());
}

export async function checkForItemId(params: { key: string }) {
  const ItemId = await localForage.getItem(params.key);

  if (ItemId && typeof ItemId === 'string') {
    return ItemId;
  } else {
    return null;
  }
}

export function eventsReadyForCheckIn(params: { data: EventData[] }) {
  const newEvents = params.data.filter((i) => {
    if (i.DateBegin && i.DateEnd) {
      const DateBegin = subDays(new Date(i.DateBegin), 3);
      const DateEnd = addDays(new Date(i.DateEnd), 2);
      return isWithinInterval(new Date(), {
        start: DateBegin,
        end: DateEnd,
      });
    } else {
      return false;
    }
  });

  return orderBy(newEvents, 'DateBegin');
}
